import api from './api';

const aircraftService = {
  // Get all aircraft for the logged-in airliner
  getAircraft: async (params = {}) => {
    const response = await api.get('/aircraft', { params });
    return response;
  },

  // Get aircraft by user ID
  getAircraftByUser: async (userId, params = {}) => {
    const response = await api.get(`/aircraft/user/${userId}`, { params });
    return response;
  },

  // Get single aircraft details
  getAircraftById: async (id) => {
    const response = await api.get(`/aircraft/${id}`);
    return response;
  },

  // Get create form data
  getCreateData: async (userId) => {
    const response = await api.get(`/aircraft/create/${userId}`);
    return response;
  },

  // Create new aircraft
  createAircraft: async (data) => {
    const response = await api.post('/aircraft', data);
    return response;
  },

  // Update aircraft
  updateAircraft: async (id, data) => {
    const response = await api.put(`/aircraft/${id}`, data);
    return response;
  },

  // Soft delete aircraft
  deleteAircraft: async (id) => {
    const response = await api.delete(`/aircraft/${id}`);
    return response;
  },

  // Permanent delete aircraft
  permanentDelete: async (id) => {
    const response = await api.delete(`/aircraft/${id}/permanent`);
    return response;
  },

  // Restore deleted aircraft
  restoreAircraft: async (id) => {
    const response = await api.post(`/aircraft/${id}/restore`);
    return response;
  },

  // Delete aircraft image
  deleteImage: async (imageData) => {
    const response = await api.post('/aircraft/images/delete', imageData);
    return response;
  },

  // Delete seating layout image
  deleteSeatingLayoutImage: async (id) => {
    const response = await api.delete(`/aircraft/${id}/seating-layout-image`);
    return response;
  },

  // Get aircraft routes
  getRoutes: async (id) => {
    const response = await api.get(`/aircraft/${id}/routes`);
    return response;
  },

  // Delete route
  deleteRoute: async (routeData) => {
    const response = await api.post('/aircraft/routes/delete', routeData);
    return response;
  },

  // Check if registration exists
  checkRegistration: async (registrationNumber) => {
    const response = await api.get('/aircraft/check/registration', {
      params: { registration_number: registrationNumber }
    });
    return response;
  },

  // Check if route exists
  checkRouteExists: async (params) => {
    const response = await api.get('/aircraft/check/route-exists', { params });
    return response;
  },

  // Get aircraft models (for dropdown)
  getAircraftModels: async () => {
    const response = await api.get('/aircraft/models/data');
    return response;
  },

  // Export aircraft data
  exportAircraft: async (format = 'excel') => {
    const response = await api.get('/aircraft/export/data', {
      params: { format },
      responseType: 'blob'
    });
    return response;
  },

  // Get aircraft images
  getImages: async (id) => {
    const response = await api.get(`/aircraft/${id}/images`);
    return response;
  },

  // Upload aircraft images
  uploadImages: async (id, files) => {
    const formData = new FormData();
    
    // Add multiple files to FormData
    if (Array.isArray(files)) {
      files.forEach(file => {
        formData.append('aircraft_image', file);
      });
    } else if (files) {
      formData.append('aircraft_image', files);
    }

    const response = await api.post(`/aircraft/${id}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  },

  // Get seating layout
  getSeatingLayout: async (id) => {
    const response = await api.get(`/aircraft/${id}/seating-layout`);
    return response;
  },

  // Get aircraft bookings
  getBookings: async (id) => {
    const response = await api.get(`/aircraft/${id}/bookings`);
    return response;
  },

  // Create aircraft route
  createRoute: async (id, data) => {
    const response = await api.post(`/aircraft/${id}/routes`, data);
    return response;
  },

  // Update aircraft route
  updateRoute: async (routeId, data) => {
    const response = await api.put(`/aircraft/routes/${routeId}`, data);
    return response;
  },

  // Delete aircraft route
  deleteRouteById: async (routeId) => {
    const response = await api.delete(`/aircraft/routes/${routeId}`);
    return response;
  },

  // Get route bookings
  getRouteBookings: async (routeId) => {
    const response = await api.get(`/aircraft/routes/${routeId}/bookings`);
    return response;
  },

  // Search aircraft models
  searchAircraftModels: async (search) => {
    const response = await api.get('/aircraft/models/data', {
      params: { search }
    });
    return response;
  },

  // Get aircraft models with pagination (for Select2-like dropdown)
  getAircraftModels: async (params = {}, signal = null) => {
    const config = { params };
    if (signal) {
      config.signal = signal;
    }
    const response = await api.get('/aircraft/models/data', config);
    return response;
  },

  // Check if registration number exists
  checkRouteExists: async (registrationNumber) => {
    const response = await api.get('/aircraft/routeExists', {
      params: { registration_number: registrationNumber }
    });
    return response;
  }
};

export default aircraftService;
